module.exports = __webpack_public_path__ + "static/media/1.01bd894c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80205/1.jpg
// module id = 761
// module chunks = 0